module.exports = __webpack_public_path__ + "static/media/wojak@2x.5dd40f9d.jpg";